import React from "react"

// ...existing code...

interface SearchContextProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  currentValue: string
  setCurrentValue: React.Dispatch<React.SetStateAction<string>>
}

export const SearchContext = React.createContext<SearchContextProps>({
  dialogOpen: false,
  setDialogOpen: () => {},
  currentValue: "",
  setCurrentValue: () => {},
})

export function SearchProvider({ children }: { children: React.ReactNode }) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [currentValue, setCurrentValue] = React.useState("")

  return (
    <SearchContext.Provider
      value={{
        dialogOpen,
        setDialogOpen,
        currentValue,
        setCurrentValue,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}
